__turbopack_context__.v({
  "slider": "dtGQGq_slider",
  "sliderWrapper": "dtGQGq_sliderWrapper",
  "wrapper": "dtGQGq_wrapper",
});
